import { Currency } from "@zapier/currency";

export const sortCurrenciesByArray = (
  a: Currency,
  b: Currency,
  array: Array<string>
) => {
  const index1 = array.indexOf(a.name),
    index2 = array.indexOf(b.name);
  return (index1 > -1 ? index1 : Infinity) - (index2 > -1 ? index2 : Infinity);
};
